import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";

const STATUS = {
  available: { label: "Verfügbar", cls: "text-[#7FE0A0]", pill: "bg-[#F4C542] text-[#32104F]" },
  reserved: { label: "Reserviert", cls: "text-[#F0A6CE]", pill: "bg-[#D85CA4] text-[#FFF9F2]" },
  sold: { label: "Verkauft", cls: "text-[#B79FD1]", pill: "bg-[#632A8E] text-[#FFF9F2]" },
};

const ASPECTS = ["aspect-[4/5]", "aspect-square", "aspect-[3/4]", "aspect-[5/4]", "aspect-[4/5]", "aspect-[3/4]"];

export default function ArtworkCard({ art, index = 0 }) {
  const st = STATUS[art.availability] || STATUS.available;
  return (
    <Link
      to={`/galerie/${art.slug}`}
      data-testid={`artwork-card-${art.slug}`}
      className="group block art-hover break-inside-avoid mb-10 bg-[#FFF9F2] rounded-md overflow-hidden shadow-[0_2px_16px_rgba(50,16,79,0.06)] hover:shadow-[0_8px_30px_rgba(50,16,79,0.12)] transition-shadow"
    >
      <div className="overflow-hidden bg-[#F3E7D2]">
        {art.main_image ? (
          <img src={mediaUrl(art.main_image, true)} alt={art.alt_text || art.title} loading="lazy" className="block w-full h-auto" />
        ) : (
          <div className={`ph bg-[#F3E7D2] w-full ${ASPECTS[index % ASPECTS.length]}`} role="img" aria-label={art.title} />
        )}
      </div>
      <div className="p-4">
        <h3 className="font-serif text-2xl leading-tight" style={{ color: "#632A8E" }}>{art.title}</h3>
        <p className="mt-1 text-sm text-[#6E5A82]">
          {[art.year, art.technique].filter(Boolean).join(" · ")}
        </p>
        <div className="mt-3 flex items-center gap-3">
          <span className={`px-2.5 py-0.5 rounded-full text-[11px] font-medium tracking-[0.1em] uppercase ${st.pill}`}>{st.label}</span>
          {art.show_price && art.price != null && (
            <span className="text-sm font-medium text-[#D85CA4]">CHF {Number(art.price).toLocaleString("de-CH")}</span>
          )}
        </div>
      </div>
    </Link>
  );
}

export { STATUS };
